import { handleActions } from 'redux-actions';
import reducersUtils from 'state/utils';
import { removeDuplicates } from 'utils/array';
import { actions as insuranceActions } from 'state/direct-order-recurring/insurance';
import { constants as aditionalOptionsConstants } from 'utils/aditionalOptions';

import actions from 'state/direct-order-recurring/extras/actionCreators';

import initialState from 'state/direct-order-recurring/extras/initial.state';

const extras = handleActions(
  {
    [reducersUtils.RESET_ORDER_STATE]: () => initialState,
    [actions.setExtra]: (state, { payload: { extra } }) => {
      return reducersUtils.reduceExtrasWithExcluyents(extra, state);
    },
    [actions.setExtras]: (state, { payload: { extrasValues } }) => [
      ...removeDuplicates([...extrasValues]),
    ],
    [insuranceActions.cleanInsurance]: (state) => [
      ...state.filter(
        (extraKey) =>
          extraKey !== aditionalOptionsConstants.ADITIONAL_OPTIONS.INSURANCE
      ),
    ],
  },
  initialState
);

export default extras;
